<div bsModal #assignAssessment="bs-modal" id="purchaseAssessment" class="modal fade" (onShown)="onShown()" role="dialog" aria-labelledby="assignAssessment" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog">

        <div #modalContent class="modal-content">
            <div class="modal-header text-center">
                <button type="button" class="close" (click)="close()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2 class="modal-title text-center">Assign Assessments</h2>
            </div>

            <div class="modal-body">
                <p>Business / Regular / 2.0</p>
                <ng-container *ngIf="!_next">
                    <div>
                        <div>
                            <label>Clients:</label>
                            <select class="clientSelect">
                                <option value="1">Mary Jonhson</option>
                                <option value="2">Joe Doe</option>
                            </select>
                            <a class="float-right">Add</a>
                        </div>
                    </div>
                    <br />
                    <br />

                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Client</th>
                                    <th>Language</th>
                                    <th>Schedule for</th>
                                    <th>Expires in</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Mary Johnson</td>
                                    <td>
                                        <select>
                                            <option value="value">English</option>
                                            <option value="value">Spanish</option>
                                        </select>
                                    </td>
                                    <td>
                                        <!--<input type="datetime-local" name="name" value="" />-->
                                        <!-- NEW DATE PICKER -->
                                        <input id="inputDatePicker" type="date" [(ngModel)]="date1">
                                        <!-- NEW DATE PICKER -->    
                                        <!-- <angular2-date-picker [(ngModel)]="date1" [settings]="settings"></angular2-date-picker> -->
                                    </td>
                                    <td>
                                        <input type="number" name="name" value="15" min="1" max="15" />
                                        <i title="Remove" (click)="removeTr($event)" class="material-icons close">close</i>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Joe Doe</td>
                                    <td>
                                        <select>
                                            <option value="value">English</option>
                                            <option value="value">Spanish</option>
                                        </select>
                                    </td>
                                    <td>
                                        <!--<input type="datetime-local" name="name" value="" />-->
                                        <!-- NEW DATE PICKER -->
                                        <input id="inputDatePicker" type="date2" [(ngModel)]="date1">
                                        <!-- NEW DATE PICKER --> 
                                        <!-- <angular2-date-picker [(ngModel)]="date2" [settings]="settings"></angular2-date-picker> -->
                                    </td>
                                    <td>
                                        <input type="number" name="name" value="15" min="1" max="15" />
                                        <i title="Remove" (click)="removeTr($event)" class="material-icons close">close</i>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Warrent Thompson</td>
                                    <td>
                                        <select>
                                            <option value="value">English</option>
                                            <option value="value">Spanish</option>
                                        </select>
                                    </td>
                                    <td>
                                        <!--<input type="datetime-local" name="name" value="" />-->
                                        <!-- NEW DATE PICKER -->
                                        <input id="inputDatePicker" type="date3" [(ngModel)]="date1">
                                        <!-- NEW DATE PICKER --> 
                                        <!-- <angular2-date-picker [(ngModel)]="date3" [settings]="settings"></angular2-date-picker> -->
                                    </td>
                                    <td>
                                        <input type="number" name="name" value="15" min="1" max="15" />
                                        <i title="Remove" (click)="removeTr($event)" class="material-icons close">close</i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-md-1 text-right">
                            <label>Tags</label>
                        </div>
                        <div class="col-md-11">
                            <div class="tags-wrap">
                                <div *ngFor="let tag of tags; let i = index;">
                                    {{tag}}
                                    <span title="Delete" (click)="removeTag(i, $event)">&times;</span>
                                </div> 
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-11 col-md-offset-1">
                            <input #newtag
                                   type="text"
                                   id="newTag"
                                   value=""
                                   placeholder="Add tag"
                                   (keyup.enter)="addTag(newtag.value)"
                                   (keypress)="preventSpace(newtag.value, $event)" />
                        </div>
                    </div>

                </ng-container>
                <ng-container *ngIf="_next">
                    <div class="next">
                        <div class="row">
                            <div class="col-md-12">
                                <label>What are your goals with these assessments?</label>
                                <select>
                                    <option selected="selected" class="option">Option 1</option>
                                    <option class="option">Option 2</option>
                                    <option class="option">Option 3</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <label>Lenght of intervention</label>
                                <select>
                                    <option selected="selected" class="option">Option 1</option>
                                    <option class="option">Option 2</option>
                                    <option class="option">Option 3</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <label>Who paid for the assessments?</label>
                                <select>
                                    <option selected="selected" class="option">Option 1</option>
                                    <option class="option">Option 2</option>
                                    <option class="option">Option 3</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            
            <div class="modal-footer text-right">
                <!--<div class="text-left">
                    <input type="checkbox" name="name" value="" checked />
                    <label>Take survey after assignment</label>
                </div>-->
                <input (click)="close()" type="button" class="btn" name="close" value="Cancel" />

                <ng-container *ngIf="!_next">
                    <input (click)="next()" type="button" class="btn btn-primary waves-effect" value="Continue" />
                </ng-container>
                <ng-container *ngIf="_next">
                    <input (click)="close()" type="button" class="btn btn-primary waves-effect" value="Continue" />
                </ng-container>
            </div>
        </div>
    </div>
</div>
